export const JACKET_TRANSITION_PROPS = {
  initial: { transform: 'translateX(-100%)', opacity: 0 },
  animate: { transform: 'translateX(0%)', opacity: 1 },
  exit: { transform: 'translateX(-100%)', opacity: 0 },
  transition: { duration: 0.25, ease: 'easeOut' },
} as const;

export const PAGE_TRANSITION_PROPS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.35, ease: 'easeOut' },
} as const;

export const DEFAULT_CLIENT_SIDE_LIMIT = 50;

export const SEARCH_DEBOUNCE_MS = 300;

export const WORKLIST_COMPACT_WIDTH_PX = 864;
